// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3EJI4","top":"styles_top__n1Yxc"};